import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-schedule-success-modal',
  templateUrl: './schedule-success-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleSuccessModalComponent {
  private readonly activeModal = inject(NgbActiveModal);

  readonly projectTypeName = signal('');
  readonly remainingProjectCount = signal(0);

  onGoToJob(): void {
    this.activeModal.close('go-to-job');
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
